import Plotly from 'plotly.js-dist-min';
const convertValue = value => {
  return Number(value)?.toLocaleString();
};
const configOptions = {
  editable: false,
  displaylogo: false,
  displayModeBar: false,
  scrollZoom: false,
  showLink: false,
  modeBarButtonsToRemove: [
    'sendDataToCloud',
    'zoom2d',
    'pan',
    'pan2d',
    'autoScale2d',
    'lasso2d',
    'autoScale2d',
    'resetScale2d',
    'toggleSpikelines',
    'dragmode',
  ],
};
export const generateActualPlanned = props => {
  const tableDataArr = { metric: [], actual: [], planned: [], benchMark: [] };
  const kpiList = props?.kpiList?.length > 0 ? props?.kpiList : [];
  const planned = props?.data?.metrics;
  const metrics_total = props?.data?.reportData?.metrics_total;
  const benchMark = props?.data?.reportData?.benchmark;
  planned?.forEach(el => {
    let row = {};
    row.kpi = kpiList?.filter(x => x?.sys_id === el?.sys_id)[0];
    row.metric =
      row.kpi?.KPI_Metric +
      (row?.kpi?.data_type === 'CURRENCY' ? ' (' + props?.data?.currency + ')' : '');
    row.planned = el.plannedValue
      ? !Number.isInteger(el.plannedValue)
        ? convertValue(el.plannedValue?.toFixed(2))
        : el.plannedValue
      : 'N/A';
    const actual = metrics_total?.filter(x => x?.key === el?.sys_id)[0]?.value.trim();
    row.actual = (actual && convertValue(actual)) || 'N/A';
    if (row.planned !== 'N/A' && row.actual !== 'N/A') {
      row.difference = !Number.isInteger(+actual - +el.plannedValue)
        ? (+actual - +el.plannedValue)?.toFixed(2)
        : +actual - +el.plannedValue;
      row.difference =
        row.difference > 0 ? '+' + convertValue(row.difference) : convertValue(row.difference);
    } else {
      row.difference = 'N/A';
    }
    row.benchMark = benchMark?.[el?.sys_id]
      ? !Number.isInteger(benchMark?.[el?.sys_id])
        ? convertValue(benchMark?.[el?.sys_id]?.toFixed(2))
        : benchMark?.[el?.sys_id]
      : 'N/A';
    tableDataArr.metric.push(row.metric);
    tableDataArr.actual.push(row.actual);
    tableDataArr.planned.push(row.planned);
    tableDataArr.benchMark.push(row.benchMark);
  });
  let traces = [];
  let y1 = 0;
  let dataforX = ['Actual', 'Planned'];
  if (tableDataArr?.metric?.length > 0 && tableDataArr?.actual?.length > 0) {
    tableDataArr.metric.map((el, index) => {
      if (tableDataArr?.planned[index] !== 'N/A' || tableDataArr?.benchMark[index] !== 'N/A') {
        y1 = y1 + 1;
        let trace = {
          x: dataforX,
          y: [tableDataArr?.actual[index], tableDataArr?.planned[index]],
          name: el,
          width: 0.1,
          opacity: 0.5,
          offsetgroup: y1,
          type: 'bar',
          yaxis: 'y' + y1,
        };
        if (tableDataArr?.benchMark[index] !== 'N/A') {
          let benchMarkTrace = {
            x: ['Actual'],
            y: [tableDataArr?.benchMark[index]],
            name: 'BenchMark Value of ' + el,
            type: 'scatter',
            mode: 'markers',
            yaxis: 'y' + y1,
            marker: {
              color: 'rgb(17, 157, 255)',
              size: 7,
              symbol: 'line-ew',
              line: {
                color: '#008000',
                width: 10,
              },
            },
          };
          traces.push({ benchMarkTrace: benchMarkTrace, trace: trace });
        } else {
          traces.push(trace);
        }
        if (y1 === 2) {
          y1 = 0;
        }
      }
    });
    let commonLayout = {
      title: 'Actual vs Planned',
      xaxis: { domain: [0.2, 0.7] },
      barmode: 'group',
      width: 680,
      // margin: { t: 10, r: 5, l: 5, b: 10 },
      yaxis: {
        // title: 'Cost per link click (EUR)',
        titlefont: { color: '#1f77b4' },
        tickfont: { color: '#1f77b4' },
      },
      yaxis2: {
        // title: 'Link clicks',
        titlefont: { color: '#ff7f0e' },
        tickfont: { color: '#ff7f0e' },
        overlaying: 'y',
        side: 'right',
      },
      yaxis3: {
        // title: 'Link click through rate',
        titlefont: { color: '#2da02d' },
        tickfont: { color: '#2da02d' },
        side: 'right',
        anchor: 'free',
        overlaying: 'y',
        position: 0.8,
      },
    };
    const res = [];
    if (traces.length > 0) {
      for (let i = 0; i < traces.length; i += 2) {
        if (traces[i]?.benchMarkTrace) {
          res.push({
            point1: traces[i]?.trace,
            point2: traces[i + 1],
            point3: traces[i]?.benchMarkTrace,
          });
        } else if (traces[i + 1]?.benchMarkTrace) {
          res.push({
            point1: traces[i],
            point2: traces[i + 1]?.trace,
            point3: traces[i + 1]?.benchMarkTrace,
          });
        } else {
          res.push({ point1: traces[i], point2: traces[i + 1] });
        }
      }
      res.map((el, index) => {
        let data = [];
        if (el.point2) {
          if (el.point3) {
            data = [el.point1, el.point2, el.point3];
          } else {
            data = [el.point1, el.point2];
          }
        } else {
          if (el.point3) {
            data = [el.point1, el.point3];
          } else {
            data = [el.point1];
          }
        }
        let layout = JSON.parse(JSON.stringify(commonLayout));
        layout.yaxis.title = el.point1?.name;
        layout.yaxis2.title = el.point2?.name;

        let node = 'actual_vs_planned' + (index + 1);
        let element = document.createElement('div');
        element.id = node;
        document.getElementById('actual_vs_planned').appendChild(element);
        Plotly.newPlot(node, data, layout, configOptions, { responsive: true });
        let ssNode = 'actual_vs_planned_ss' + (index + 1);
        let ssEl = document.createElement('div');
        ssEl.id =  ssNode;
        document.getElementById('actual_vs_planned_ss').appendChild(ssEl);
        Plotly.newPlot(ssNode, data, layout, configOptions, { responsive: true });
        const actual_vs_plan = document.getElementById(node);
        actual_vs_plan.on('plotly_restyle', ([updatedData, tracesTouched]) => {
          restyle(updatedData, tracesTouched, node);
        });
      });
      const restyle = (updatedData, tracesTouched, id) => {
        const yIndex = tracesTouched[0] === 0 ? 'yaxis.visible' : 'yaxis2.visible';
        const visiblity = updatedData.visible[0] === true ? true : false;
        Plotly.relayout(id, { [yIndex]: visiblity });
      };
    } else {
      props?.setActualVsPlanNodata(true);
    }
  } else {
    props?.setActualVsPlanNodata(true);
  }
};
